import 'lazysizes';
// eslint-disable-next-line import/no-unresolved
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

window.lazySizes.cfg.expand = -380;

if (document.addEventListener) {
  document.addEventListener('lazybeforeunveil', function (e: any) {
    if (e.detail.instance != window.lazySizes) {
      return;
    }

    if (!e.defaultPrevented) {
      const target = e.target;
      const $e = $(target);
      const code = $e.data('lazyload-script');

      if (code) {
        try {
          if (typeof code === 'function') {
            $e.data('lazyload-script')();
          } else {
            eval(code.replace('this', 'target'));
          }
          e.detail.firesLoad = false;
          window.lazySizes.fire(target, '_lazyloaded', {}, true, true);
        } catch (e: any) {
          (e.detail || {}).firesLoad = false;
          console.error('🔴 lazyload-script', e);
        }
      } else if ($e.hasClass('lazyload-children')) {
        if ($e.children().hasClass('data-lazy-noscript')) {
          $e.html($e.children().html());
        }

        (e.detail || {}).firesLoad = false;
        $e.children().removeClass('d-none');
        window.lazySizes.fire(target, '_lazyloaded', {}, true, true);
      }
    }
  });
}
